export const translations = {
	'Authentication Key': {
		no: 'Autentiseringsnøkkel',
	},
	'Logo Image': {
		no: 'Logo bilde',
	},
	'Account details': {
		no: 'Konto detaljer',
	},
	'Create new configuration': {
		no: 'Opprett ny konfigurasjon',
	},
	'Create new configuration warning': {
		no: 'For å opprette en ny konfigurasjon må du først lagre kontoen. Ønsker du å lagre kontoen og fortsette til konfigurasjon klikk OK, om ikke klikk Avbryt.',
	},
	'Set logo image': {
		no: 'Standard logo er satt. klikk her eller + symbol for å sette egen logo',
	},
	'Integrate ad module': {
		no: 'For å lage en ny konfigurasjo må AD integrasjonsmodulen installeres. Hvis du vil installere AD integrasjonsmodulen og fortsette til konfigurasjonen, klikker du OK. Hvis ikke, klikk AVBRYT.',
	},
	'AD Integration module missing': {
		no: 'AD integrasjonsmodul mangler',
	},
	'Logo add sign tooltip': {
		no: 'Klikk for å redigere logobildet',
	},
	'Authentication key can be created after account is created.': {
		no: 'Autentiseringsnøkkel kan opprettes etter at kontoen er opprettet.',
	},
	'Are you sure you want to delete this authentication key? It must be replaced everywhere it is used.': {
		no: 'Er du sikker på at du vil slette denne autentiseringsnøkkelen? Den må erstattes alle steder den er i bruk.',
	},
	'Service Configuration': {
		no: 'Tjeneste konfigurasjon',
	},
	'Create new profile': {
		no: 'Opprett ny profil',
	},
	'Create new profile warning': {
		no: 'For opprette en ny profil må du lagre konfigurasjonen. Ønsker du å lagre og fortsette til profil klikk OK, om ikke klikk Avbryt.',
	},
	'Click to add a LDAP host': {
		no: 'Klikk for å legge til en LDAP vert',
	},
	'Account Services Configuration': {
		no: 'Konto tjenester konfigurasjon',
	},
	'Account description': {
		no: 'Konto beskrivelse',
	},
	'Choose a tag...': {
		no: 'Etikett er satt...',
	},
	'There are no tags': {
		no: 'Velg etikett...',
	},
	'Account successfully created.': {
		no: 'Konto opprettet',
	},
	'Account information successfully updated.': {
		no: 'Konto informasjon oppdatert',
	},
	'Please, input the name of the account': {
		no: 'Fyll inn konto navn.',
	},
	'Input team name': {
		no: 'Sett inn navn på team',
	},
	'New account': {
		no: 'Ny konto',
	},
	'Create account': {
		no: 'Lag konto',
	},
	'Are you sure you want to remove account?': {
		no: 'Vil du slette konto?',
	},
	'Account successfully deleted.': {
		no: 'Kontoen er slettet',
	},
	'You are not able to delete current account, it must be done from an account above current account context': {
		no: 'Du kan ikke slette gjeldende konto, det må gjøres fra konto på nivået over.',
	},
	'Asset successfully created.': {
		no: 'Ressursen er opprettet',
	},
	'Please complete the following form in order to create a <strong>new assetgroup</strong>.': {
		no: 'Fyll ut følgende skjema for å lage en <strong>Ny ressursgruppe</strong>',
	},
	'Please complete the following form in order to update this assetgroup details.': {
		no: 'Fyll ut følgende skjema for å oppdatere beskrivelsen for ressursgruppen',
	},
	'Assetgroup name': {
		no: 'Ressursgruppe navn',
	},
	'Assetgroup description': {
		no: 'Beskrivelse',
	},
	'Assetgroup successfully created.': {
		no: 'Ressursgruppe er opprettet',
	},
	'Assetgroup successfully updated.': {
		no: 'Ressursgruppe er oppdatert',
	},
	'Please, input the name of the assetgroup.': {
		no: 'Skriv inn navn på ressursgruppen',
	},
	'Select Authentication type...': {
		no: 'Velg autentiseringtype...',
	},
	'Authentication successfully created': {
		no: 'Autentisering er opprettet',
	},
	'Authentication successfully updated': {
		no: 'Autentisering er oppdatert',
	},
	'Authentication details': {
		no: 'Autentiseringdetaljer',
	},
	'Please, input the name of the authentication.': {
		no: 'Skriv inn navn på autentiseringen',
	},
	'Please, select an authentication type': {
		no: 'Velg autentiseringstype',
	},
	'Community passphrase': {
		no: 'Community passord',
	},
	'Privacy passphrase': {
		no: 'Privacy passord',
	},
	'Auth passphrase': {
		no: 'Auth passord',
	},
	'Domain': {
		no: 'Domene',
	},
	'Param1': {
		no: 'Param1',
	},
	'Param2': {
		no: 'Param2',
	},
	'Param3': {
		no: 'Param3',
	},
	'Param4': {
		no: 'Param4',
	},
	'Param5': {
		no: 'Param5',
	},
	'Host': {
		no: 'Vert',
	},
	'Connection string': {
		no: 'Tilkoblingstreng',
	},
	'Private key': {
		no: 'Privat nøkkel',
	},
	'Community PW': {
		no: 'Community PW',
	},
	'Security level': {
		no: 'Sikkerhetsnivå',
	},
	'Security name': {
		no: 'Security navn',
	},
	'Privacy': {
		no: 'Privacy',
	},
	'Engine id': {
		no: 'Engine ID',
	},
	'Context engine id': {
		no: 'Context engine ID',
	},
	'Context name': {
		no: 'Context navn',
	},
	'Access key id': {
		no: 'Access Key ID',
	},
	'Secret access key': {
		no: 'Secret Access Key',
	},
	'AWS region': {
		no: 'AWS Region',
	},
	'Subscription id': {
		no: 'Subscription ID',
	},
	'Tenant': {
		no: 'Tenant',
	},
	'Client': {
		no: 'Client',
	},
	'Project id': {
		no: 'Project ID',
	},
	'Dataset': {
		no: 'Datasett',
	},
	'New authentication': {
		no: 'Ny autentisering',
	},
	'Are you sure you want to remove authentication?': {
		no: 'Vil du slette autentisering',
	},
	'Authentication successfully deleted': {
		no: 'Autentisering er slettet',
	},
	'Are you sure you want to remove authentications?': {
		no: 'Vil du slette autentiseringene?',
	},
	'Authentication ${name} must be replaced in the below components before it can be deleted. Click replace all button to continue.':
		{
			no: 'Autenisering ${name} må fjernes fra følgende elementer før den kan slettes.',
		},
	'Calendar deleted': {
		no: 'Kalenderene er slettet',
	},
	'Are you sure you want to remove calendars?': {
		no: 'Er du sikker på at du vil slette kalenderene',
	},
	'Are you sure you want to remove calendar?': {
		no: 'Er du sikker på at du vil slette kalender',
	},
	'The ${calendarName} calendar must be removed from the following items before it can be deleted.': {
		no: 'Kalenderen ${calendarName} må fjernes fra følgende elementer før den kan slettes.',
	},
	'Remove from all': {
		no: 'Fjern fra alle',
	},
	'This type is only supported via script': {
		no: 'Denne typen er bare supportert med skript',
	},
	'This group has checked <strong>${checkedNr}</strong> out of <strong>${totalNr}</strong> permissions': {
		no: 'Denne gruppen har <strong>${checkedNr}</strong> rettigheter selektert av totalt <strong>${totalNr}</strong>',
	},
	'Requested change will migrate role to new permission scheme, please ensure that required menue items have been selected of cancel change':
		{
			no: 'Valgt endring vil migrere rollen til ny rettighetssystem, sjekk at alle ønskede menyer er valgt eller kanseller endring',
		},
	'Are you sure you want to remove role?': {
		no: 'Vil du slette rolle?',
	},
	'Role was successfully deleted': {
		no: 'Rolle er slettet',
	},
	'Are you sure you want to remove roles?': {
		no: 'Vil du slette rollene?',
	},
	'Roles were successfully deleted': {
		no: 'Rollene er slettet',
	},
	'Please, input team name': {
		no: 'Skriv inn navn på team',
	},
	'Team successfully created': {
		no: 'Team er opprettet',
	},
	'Team successfully updated': {
		no: 'Team er oppdatert',
	},
	'Assetgroup': {
		no: 'Ressursgruppe',
	},
	' Click delete to delete notification': {
		no: ' Klikk slett for å fjerne varselet',
	},
	'Are you sure you want to remove notifications?': {
		no: 'Vil slette meldingene?',
	},
	'Notification is disabled': {
		no: 'Varsling er deaktivert',
	},
	'Team users': {
		no: 'Team brukere',
	},
	'There are no users in team': {
		no: 'Det er ingen brukere i team',
	},
	'There is currently, 1 user in team': {
		no: 'Det er en bruker i team',
	},
	'There are currently,': {
		no: 'Det er',
	},
	'users in this team': {
		no: 'brukere i team',
	},
	'New team': {
		no: 'Nytt team',
	},
	'Are you sure you want to remove team?': {
		no: 'Vil slette team?',
	},
	'Team successfully deleted': {
		no: 'team er slettet',
	},
	'Are you sure you want to remove teams?': {
		no: 'Vil du slette team?',
	},
	'Please remove team ${name} from the following items before it can be deleted': {
		no: 'Du må fjerne team ${name} fra følgende elementer før det kan slettes',
	},
	'The import was successful. Please verify new templates in grid': {
		no: 'Fullført importering. Sjekk nye maler i tabell',
	},
	'Service element templates': {
		no: 'Tjenesteelement maler',
	},
	'Are you sure you want to remove service element template?': {
		no: 'Vil du slette tjenesteelement mal?',
	},
	'Service element template deleted': {
		no: 'Tjenesteelement mal var slettet',
	},
	'Service element template details': {
		no: 'Tjenesteelement mal detaljer',
	},
	'Service element template successfully updated': {
		no: 'Tjenesteelement mal oppdatert',
	},
	'Servicemodel templates': {
		no: 'Tjenestemodell maler',
	},
	'Are you sure you want to remove servicemodel template?': {
		no: 'Vil du slette tjenestemodell mal?',
	},
	'Servicemodel template was deleted': {
		no: 'Tjenestemodell er slettet',
	},
	'Servicemodel template details': {
		no: 'Tjenestemodell mal detaljer',
	},
	'Servicemodel template successfully updated': {
		no: 'Tjenestemodell mal er oppdatert',
	},
	'Are you sure you want to remove servicequalifier template?': {
		no: 'Vil du slette tjenestepunkt mal',
	},
	'Servicequalifier template deleted': {
		no: 'Tjenestepunkt mal slettet',
	},
	'Servicequalifier template details': {
		no: 'Tjenestepunkt mal detaljer',
	},
	'Servicequalifier template successfully updated': {
		no: 'Tjenestepunkt mal er oppdatert',
	},
	'Select account...': {
		no: 'Velg konto...',
	},
	'Select role...': {
		no: 'Velg rolle...',
	},
	'Select time zone...': {
		no: 'velg tidssone...',
	},
	'Choose teams...': {
		no: 'Velg team...',
	},
	'User successfully created': {
		no: 'Bruker opprettet',
	},
	'User profile successfully saved': {
		no: 'Brukerprofilen oppdatert',
	},
	'Please, input username': {
		no: 'Legg til brukernavn',
	},
	'Password must have minimum 6 characters and not be identical to previous password': {
		no: 'Passordet må minst ha 6 bokstaver og ikke væære identisk med forrige passord',
	},
	'The password must differ from username': {
		no: 'Passordet må vÆre forskjellig fra brukernavnet',
	},
	'Confirmation password is wrong': {
		no: 'Passordet er feil',
	},
	'Please, input first name': {
		no: 'Legg til fornavn',
	},
	'Please, input last name': {
		no: 'Legg til etternavn',
	},
	'The email address is invalid': {
		no: 'E-post addresse er ikke gyldig',
	},
	'Please complete all required fields': {
		no: 'Fyll inn alle påkrevde felt',
	},
	'- Ceeview home view - ': {
		no: '- Ceeview hjem skjerm',
	},
	'- Dashboards -': {
		no: '- Dashboard -',
	},
	'LDAP type user must handle password in AD': {
		no: 'LDAP type bruker må håndtere passord i AD',
	},
	'The two passwords must be identical': {
		no: 'Passordene må være identiske',
	},
	'New user': {
		no: 'Ny bruker',
	},
	'Create user': {
		no: 'Lag bruker',
	},
	'Are you sure you want to remove user?': {
		no: 'Vil slette bruker',
	},
	'User successfully deleted': {
		no: 'Bruker er slettet',
	},
	'Please remove user ${name} from the following items before it can be deleted': {
		no: 'Bruker ${name} må fjernes fra følgende elementer før den kan slettes',
	},
	'Are you sure you want to remove users?': {
		no: 'Vil du slette brukerene?',
	},
};
